// Versioned local asset: the user's supplied, unmodified revised-2026 conditions.
export const IMPORT_CONDITIONS_PATH = '/documents/cayman-islands-import-conditions-october-2026.pdf';
export const IMPORT_CONDITIONS_URL = `${process.env.REACT_APP_BACKEND_URL}${IMPORT_CONDITIONS_PATH}`;
export const IMPORT_CONDITIONS_FILENAME = 'Cayman-Islands-Importation-Conditions-2026.pdf';